export default "__VITE_ASSET__Bu3vqY1t__"